"use client";

import { c as _c } from "react/compiler-runtime";
import { useCancelListing, type CancelListingProps } from "../../flows/useCancelListing";
import { useOfferDecision, type OfferDecisionProps } from "../../flows/useOfferDecision";
import { FlowDialog } from "./FlowDialog";

/** Cancel the listing, in v2 — nothing to enter; every rule is `useCancelListing`'s. */
export function CancelListingDialog(props) {
  const $ = _c(2);
  const {
    model
  } = useCancelListing(props);
  let t0;
  if ($[0] !== model) {
    t0 = <FlowDialog m={model} />;
    $[0] = model;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}

/** Accept or cancel an offer, in v2 — the question asked about its exact figure; every rule is `useOfferDecision`'s. */
export function DecisionDialog(props) {
  const $ = _c(2);
  const {
    model
  } = useOfferDecision(props);
  let t0;
  if ($[0] !== model) {
    t0 = <FlowDialog m={model} />;
    $[0] = model;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}